import React from 'react';
import '../styles/Footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <nav aria-label="Redes sociais" className="footer__social">
        <p>Siga-nos:</p>
        <ul>
          <li>
            <a
              href="https://www.facebook.com/share/1675LjYSRi/"
              target="_blank"
              rel="noopener noreferrer"
              title="Facebook"
            >
              Facebook
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              title="Twitter"
            >
              Twitter
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/resumiprati?utm_source=qr&igsh=OGp5YWQ4aHN1YnZq"
              target="_blank"
              rel="noopener noreferrer"
              title="Instagram"
            >
              Instagram
            </a>
          </li>
        </ul>
      </nav>
      <p>&copy; 2025 Resumi Pra Ti</p>
      <p className="footer__disclaimer">
        Os conteúdos apresentados são resumos gerados automaticamente a partir de notícias públicas. Para acessar a notícia completa, clique na fonte indicada em cada notícia.
      </p>
    </footer>
  );
};

export default Footer;